import React from "react";

import { Form, InputNumber, Input, DatePicker, Select, TreeSelect } from "antd";
import CustomNumOfAmt from "components/NumOfAmt";
const { Option } = Select;

export const EditCell = ({
  editing,
  dataIndex,
  title,
  fieldType,
  options = [
    { val: true, txt: "Идэвхтэй" },
    { val: false, txt: "Идэвхгүй" },
  ],
  children,
  value,
  required = true,
  onLoadData,
  ...restProps
}) => {
  // fieldType === "checkbox" ? (
  //   <Checkbox
  //     defaultChecked={value}
  //   />
  // ) :
  const inputNode =
    fieldType === "number" ? (
      <InputNumber style={{ width: "100%" }} {...restProps} />
    ) : fieldType === "date" ? (
      <DatePicker />
    ) : fieldType === "select" ? (
      <Select style={{ width: "100%" }} placeholder="Сонгоно уу!" allowClear>
        {options.map((row) => (
          <Option key={row.val} value={row.val}>{`${row.txt}`}</Option>
        ))}
      </Select>
    ) : fieldType === "treeselect" ? (
      <TreeSelect
        allowClear
        treeDataSimpleMode
        style={{ width: "100%" }}
        value={value}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        placeholder="Сонгоно уу!"
        loadData={onLoadData}
        treeData={options}
        {...restProps}
      />
    ) : fieldType === "amount" ? (
      <CustomNumOfAmt value={value} style={{ width: "100%" }} {...restProps} />
    ) : (
      <Input style={{ width: "100%" }} {...restProps} />
    );

  return (
    <td>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={
            required
              ? [
                  {
                    required: true,
                    message: `${title} хоосон байна!`,
                  },
                ]
              : []
          }
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
